export default "__VITE_ASSET__Ctn_kUE___"